import React, { Component } from 'react'
import { connect } from 'react-redux'
import qs from 'qs'
import CardContent from '@material-ui/core/CardContent';
import { GlobalLoaderActions } from 'actionsets'
import StyleSheet from 'styles'

export class LinkedInCallback extends Component{

  constructor(props){
    super(props)
    GlobalLoaderActions.bindActions(this, 'loader')
  }
  componentDidMount = () => {
    let query = qs.parse(window.location.search.substring(1))
    this.actions.loader.startLoad()
    if(window.opener) {
      setTimeout(() => {
        window.opener.postMessage(query, '*')
      }, 2000)
    }
  }

  render = () => {
    return (
      <CardContent className={styles.content}/>
    )
  }
}

const styles = StyleSheet({
  headline: {
    width: '100%',
    textAlign: 'center'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }
})

export default connect()(LinkedInCallback)